<script setup lang="ts">
import useManageFile from "@/modules/useManageFile";
import { onMounted, onUnmounted, nextTick } from "vue";

interface Props {
    title: string;
    titleDetail?: string;
    description: string;
    eventId: string;
    imagePath?: string;
}

const props = defineProps<Props>();

const { getEventFile } = useManageFile();

onMounted(() => {
    nextTick(async () => {
        const eventUrl = `${window.location.origin}/acesevent/${props.eventId}`;
        const title = props.titleDetail !== undefined && props.titleDetail !== null && props.titleDetail !== "" ? `${props.title} - ${props.titleDetail}` : props.title;
        const eventImage = props.imagePath !== undefined && props.imagePath !== null && props.imagePath !== "" ? await getEventFile(
            props.eventId,
            props.imagePath
        ) : `${window.location.origin}/assets/logo.png`;

        document.title = title;
        document.querySelector("meta[name=\"og:title\"]")?.setAttribute("content", title);
        document.querySelector("meta[name=\"description\"]")?.setAttribute("content", props.description);
        document.querySelector("meta[name=\"og:description\"]")?.setAttribute("content", props.description);
        document.querySelector("meta[name=\"og:url\"]")?.setAttribute("content", eventUrl);
        document.querySelector("meta[name=\"og:image\"]")?.setAttribute("content", eventImage);
    });
});

onUnmounted(() => {
    document.title = "Aces Poker Run";
    document.querySelector("meta[name=\"og:title\"]")?.setAttribute("content", "Aces Poker Run");
    document.querySelector("meta[name=\"description\"]")?.setAttribute("content", "");
    document.querySelector("meta[name=\"og:description\"]")?.setAttribute("content", "");
    document.querySelector("meta[name=\"og:url\"]")?.setAttribute("content", "");
    document.querySelector("meta[name=\"og:image\"]")?.setAttribute("content", "");
});

</script>
<template>
    <span></span>
</template>
